import { render, staticRenderFns } from "./MainForm.vue?vue&type=template&id=aabd5f7e&scoped=true&"
import script from "./MainForm.vue?vue&type=script&lang=js&"
export * from "./MainForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabd5f7e",
  null
  
)

export default component.exports